"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeRequestOptions = exports.applySomeDefaults = exports.applyDefaults = exports.retry = exports.delay = void 0;

var ms_1 = __importDefault(require("ms"));

function delay(time) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, (0, ms_1.default)(time));
  });
}

exports.delay = delay;

function retry(_x, _x2) {
  return _retry.apply(this, arguments);
}

function _retry() {
  _retry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(execution, attempts) {
    var waitTime,
        failedAttemptCallback,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            waitTime = _args.length > 2 && _args[2] !== undefined ? _args[2] : '1s';
            failedAttemptCallback = _args.length > 3 ? _args[3] : undefined;

          case 2:
            if (!(attempts > 0)) {
              _context.next = 21;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return execution();

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            attempts--;

            if (!(attempts > 0)) {
              _context.next = 18;
              break;
            }

            if (failedAttemptCallback) {
              failedAttemptCallback(attempts);
            }

            _context.next = 16;
            return delay(waitTime);

          case 16:
            _context.next = 19;
            break;

          case 18:
            throw _context.t0;

          case 19:
            _context.next = 2;
            break;

          case 21:
            throw new Error('Please specify more than one attempt for the retry function');

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
  return _retry.apply(this, arguments);
}

exports.retry = retry;
/** Add defaults to missing properties in the partial object */

function applyDefaults(defaults, partial) {
  return _objectSpread({}, defaults, partial);
}

exports.applyDefaults = applyDefaults;
/** Add some defaults to missing properties in the partial object. This means that the object is not yet complete */

function applySomeDefaults(defaults, partial) {
  return _objectSpread({}, defaults, partial);
}

exports.applySomeDefaults = applySomeDefaults;
/**  As headers field is Record<string, string> type, then when merging request Options
     it's needed to merge the array instead of just applying the defaults.           */

function mergeRequestOptions(target, source) {
  var combinedHeaders = _objectSpread({}, target === null || target === void 0 ? void 0 : target.headers, source === null || source === void 0 ? void 0 : source.headers);

  var combinedCookies = _objectSpread({}, target === null || target === void 0 ? void 0 : target.cookies, source === null || source === void 0 ? void 0 : source.cookies);

  return _objectSpread({}, target, source, {
    headers: combinedHeaders,
    cookies: combinedCookies
  });
}

exports.mergeRequestOptions = mergeRequestOptions;